import React, { useRef, useState } from 'react';
import NavigationItem from './NavigationItem';

const NavigationMenuItem = ({ links = [], contentLink = null }) => {
    const menuRef = useRef(null);
    const linkRef = useRef(null);
    const [showDropdown, setShowDropdown] = useState(false);
    
    const toggleMenu = () => {
        setShowDropdown(!showDropdown);
        menuRef.current.classList.toggle('navbar__menu--show');
    };

    const toggleDropdown = () => {
        if (showDropdown && menuRef.current.contains(document.activeElement)) {
            return;
        }
        setShowDropdown(!showDropdown);
    };

    const handleKeyDown = (e) => {
        if (e.key === "ArrowDown" && !showDropdown) {
            e.preventDefault();
            setShowDropdown(true);
        }

        if (e.key === "ArrowUp" && showDropdown) {
            e.preventDefault();
            setShowDropdown(false);
            linkRef.current.focus();
        }
    };

    const additionClass =
        contentLink && contentLink.attributes
            ? contentLink.attributes.cssValue
            : null;
    const selectedClass =
        contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const hasNameOrChildren = (link) =>
        link.name || (link.links || []).length > 0;

    return (
        <li
            className="navbar__item"
            onMouseEnter={toggleDropdown}
            onMouseLeave={toggleDropdown}
        >
            <a
                className={`navbar__link ${selectedClass} ${
                    hasChildrenClass || ''
                } ${additionClass || ''}`}
                href={contentLink.url || '#'}
                dangerouslySetInnerHTML={{ __html: contentLink.name }}
                onKeyDown={handleKeyDown}
                ref={linkRef}
            ></a>
            <i
                className="navbar__icon--caret-right navbar__icon navbar__icon--open"
                onClick={toggleMenu}
            ></i>
            {showDropdown &&
                <ul className="navbar__menu" ref={menuRef} onKeyDown={handleKeyDown}>
                    <div className="navbar__menu-header">
                        <i
                            className="navbar__icon--caret-left navbar__icon"
                            onClick={toggleMenu}
                        ></i>
                        <span
                            className="navbar__title"
                            onClick={toggleMenu}
                            dangerouslySetInnerHTML={{
                                __html: contentLink.name,
                            }}
                        ></span>
                    </div>
                    {links.map((link) =>
                        hasNameOrChildren(link) && (
                            <NavigationItem
                                links={link.links}
                                contentLink={link}
                                key={link.url}
                            />
                        )
                    )}
                </ul>
            }
        </li>
    );
};

export default NavigationMenuItem;
